<!-- 产品优势 -->
<template>
    <div class="container">
        <div class="section">
            <div class="label">产品覆盖</div>
            <div class="content">
                <div class="item">
                    <img src="@/assets/image/choiceYC/productAdvantage/icon_1.png" style="height: 180px;width: 180px"
                         alt/>
                    <div class="title">68家企事业单位提供信息化服务</div>
                    <div class="info">海量的数据分析处理能力，提供便捷直观的大数据可视化展示，便于决策指挥调度</div>
                </div>
                <div class="item center">
                    <img src="@/assets/image/choiceYC/productAdvantage/icon_2.png" style="height: 180px;width: 180px"
                         alt/>
                    <div class="title">助力超46家单位成功创建示范县</div>
                    <div class="info">为各县区申创示范县提供全方位技术咨询服务保障</div>
                </div>
                <div class="item">
                    <img src="@/assets/image/choiceYC/productAdvantage/icon_3.png" style="height: 180px;width: 180px"
                         alt/>
                    <div class="title">22万公里+自动化检测</div>
                    <div class="info">全国16个省份累计开展自动化检测高速+普通公路+农村公路达22万公里</div>
                </div>
            </div>
        </div>
        <div class="section" style="background-color: #EAF3FF;">
            <div class="label">国内领先的养护大数据分析平台</div>
            <div class="content">
                <div class="item">
                    <img src="@/assets/image/choiceYC/productAdvantage/icon_4.png" style="height: 126px;width: 126px"
                         alt/>
                    <div class="title">大数据应用分析</div>
                    <div class="info">多源异构的海量数据进行深度融合</div>
                </div>
                <div class="item center">
                    <img src="@/assets/image/choiceYC/productAdvantage/icon_5.png" style="height: 126px;width: 126px"
                         alt/>
                    <div class="title">先进的算法赋能</div>
                    <div class="info">AI智能化巡检，实测海量数据，实现识别准确率达95%</div>
                </div>
                <div class="item">
                    <img src="@/assets/image/choiceYC/productAdvantage/icon_6.png" style="height: 126px;width: 126px"
                         alt/>
                    <div class="title">高效自动化检测能力</div>
                    <div class="info">
                        三台成套多功能检测设备，8名固定外业检测人员，23名内业数据分析人员，实际检测已超22万公里
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'productAdvantage',
    data() {
        return {};
    },
    methods: {},
};
</script>

<style lang='scss' scoped>
.container {
    height: 100%;
    width: 100%;

    .section {
        padding: 100px 0;

        .label {
            font-size: 28px;
            text-align: center;
        }

        .content {
            display: flex;
            justify-content: center;
            margin: 50px auto 0 auto;
            width: 1080px;

            .item {
                width: 22rem;
                text-align: center;
                color: #333333;

                .title {
                    margin-top: 50px;
                    margin-bottom: 16px;
                    font-size: 22px;
                }

                .info {
                    font-size: 14px;
                    line-height: 22px;
                }
            }

            .center {
                margin: 0 64px;
            }
        }
    }
}

@import "./style.scss";
</style>
